import React, { useState } from "react";
import "../../styles/ControlQuestionCard.scss";

const ChevronRight = () => (
    <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
        <path d="M6 4l4 4-4 4" stroke="#4a5a7a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const WarningIcon = () => (
    <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
        <path d="M8 1.5L1.5 13.5h13L8 1.5z" stroke="#f59e0b" strokeWidth="1.5" strokeLinejoin="round" />
        <path d="M8 6v3.5" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="8" cy="11.5" r="0.75" fill="#f59e0b" />
    </svg>
);

export default function ControlQuestionCard({
    title,
    description,
    itemId,
    service,
    status = "Pass",
    checkName,
    findingsMessage = "There are no findings for these regions"
}) {
    const [checkOpen, setCheckOpen] = useState(true);

    return (
        <div className="control-question-card">
            {/* Title row */}
            <div className="card-header">
                <span className="card-title">
                    {title}
                </span>
                <span className={`status-badge ${(status || '').toLowerCase()}`}>
                    {status}
                </span>
            </div>

            {/* Description */}
            <div className="card-description-section">
                <p className="section-label">Description</p>
                <p className="description-text">
                    {description}
                </p>
            </div>

            {/* Meta badges */}
            <div className="card-meta-section">
                <div className="meta-item">
                    <span className="meta-label">Item ID:</span>
                    <span className="meta-value">{itemId}</span>
                </div>
                <div className="meta-divider" />
                <div className="meta-item">
                    <span className="meta-label">Service:</span>
                    <span className="meta-value">{service}</span>
                </div>
            </div>

            {/* Collapsible check block */}
            <div className="check-block-section">
                <div className="check-container">
                    {/* Check header */}
                    <div
                        onClick={() => setCheckOpen(!checkOpen)}
                        className={`check-header ${checkOpen ? 'open' : ''}`}
                    >
                        <div className="check-info">
                            <span className="check-index">1</span>
                            <span className="check-label">Check</span>
                        </div>
                        <div className={`chevron-container ${checkOpen ? 'expanded' : ''}`}>
                            <ChevronRight />
                        </div>
                    </div>

                    {/* Sub-item: check name */}
                    {checkOpen && (
                        <div className="check-content">
                            <span className="check-name">
                                {checkName}
                            </span>
                        </div>
                    )}
                </div>
            </div>

            {/* Warning footer */}
            <div className="card-footer-warning">
                <WarningIcon />
                <span className="warning-text">
                    {findingsMessage}
                </span>
            </div>
        </div>
    );
}

